import React from "react";
import ThriveservicePlus from 'assets/img/Thrive Service Plus.png';


const WelcomeMessage = () => {
    return (
        <div
            style={{
                textAlign: "center",
                color: "#4a4a4a",
                padding: "30px",
                fontSize: "15px",
                lineHeight: "1.7",
                height: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent:"center"                
            }}
        >
            <div>
                <img src={ThriveservicePlus} width="400px" alt="" />
                <p style={{ fontWeight: "bold", color: "#333", marginBottom: "20px" }}>
                    Thank you for choosing Thrive Service Plus!
                </p>
                <p style={{ fontWeight: "bold", color: "#333", marginBottom: "20px" }}>
                    *Please allow three business days to complete your enrollment.*
                </p>             
                <p>Questions? Your dedicated concierge team is here to help. Contact them today at 833.473.4968</p>
            </div>
        </div>
    );
};

export default WelcomeMessage;